import { colors } from '@beelday/common'

/**
 * Two-tone illustrations for the resting screens. Not glyphs - they carry
 * two brand colours - so they live here rather than in the shared `icons`.
 */

/** A screen with a rising line: something is being presented at the front. */
export const PresentationIllustration = (): JSX.Element => (
	<svg width="48" height="48" viewBox="0 0 46 46" fill="none" aria-hidden>
		<rect
			x="6"
			y="9"
			width="34"
			height="22"
			rx="3"
			stroke={colors.indigoBlue}
			strokeWidth="2"
		/>
		<path
			d="M17 37h12M23 31v6"
			stroke={colors.indigoBlue}
			strokeWidth="2"
			strokeLinecap="round"
		/>
		<path
			d="M14 22l5-6 4 4 6-8"
			stroke={colors.greenishCyan}
			strokeWidth="2.2"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</svg>
)

export const SpeakerIllustration = (): JSX.Element => (
	<svg width="48" height="48" viewBox="0 0 44 44" fill="none" aria-hidden>
		<path
			d="M9 17h6l8-7v24l-8-7H9z"
			stroke={colors.indigoBlue}
			strokeWidth="2"
			strokeLinejoin="round"
		/>
		<path
			d="M29 16a8 8 0 010 12M33 12a14 14 0 010 20"
			stroke={colors.greenishCyan}
			strokeWidth="2.2"
			strokeLinecap="round"
		/>
	</svg>
)

/** The menu glyph; the shared `icons` set has none. */
export const HamburgerIcon = (): JSX.Element => (
	<svg width="18" height="14" viewBox="0 0 17 13" fill="none" aria-hidden>
		<path
			d="M1 1.5h15M1 6.5h15M1 11.5h15"
			stroke="currentColor"
			strokeWidth="2"
			strokeLinecap="round"
		/>
	</svg>
)
